import {Card, Form, Row, Col, Button, Spinner} from 'react-bootstrap'
import {HSDescriptionDetail} from '../core/_models'
import SummernoteEditor from '../../../../../ui-kit/SummerNote/SummerNote'

type Props = {
  isLoadingHS: boolean
  hsOrigin: HSDescriptionDetail
  hsPending: HSDescriptionDetail
  isDifferent: (val1: any, val2: any) => boolean
  handleChange: (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>
  ) => void
  handleSelectChange: (e: React.ChangeEvent<HTMLSelectElement>) => void
  handleCancel: () => void
  handleSubmit: () => void
  isLoadingButton: boolean
  isFormValid: boolean
}

const HSDescriptionPendingForm: React.FC<Props> = ({
  isLoadingHS,
  hsOrigin,
  hsPending,
  isDifferent,
  handleChange,
  handleSelectChange,
  handleCancel,
  handleSubmit,
  isLoadingButton,
  isFormValid,
}) => {
  return (
    <Row className='mb-5 h-100'>
      <Col className='h-100'>
        <Card className='h-100'>
          <Card.Header className='card-header-stretch'>
            <Card.Title className='w-100'>
              <div className='title-container w-100 d-flex justify-content-between align-items-center'>
                <div className='title d-flex align-items-center'>
                  <span className='fa fa-file-alt px-2'></span>
                  <h3 className='text-gray-700'>Pending Review Content</h3>
                </div>
              </div>
            </Card.Title>
          </Card.Header>
          <Card.Body>
            {!isLoadingHS ? (
              <Form>
                <div className='row'>
                  <div className='col-12'>
                    <h3>General Information</h3>
                  </div>
                  <div className='col-md-6'>
                    <Form.Label className='text-primary me-0 ps-0' column>
                      <span
                        className={`required ${
                          isDifferent(hsOrigin.id, hsPending.id) ? 'label-highlight' : ''
                        }`}
                      >
                        ID
                      </span>
                    </Form.Label>
                    <Form.Control
                      type='text'
                      placeholder='Enter ID'
                      name='id'
                      className='required'
                      value={hsPending.id || ''}
                      onChange={handleChange}
                    />
                  </div>
                  <div className='col-md-6'>
                    <Form.Label className='text-primary me-0 ps-0' column>
                      <span
                        className={`required ${
                          isDifferent(hsOrigin.version, hsPending.version) ? 'label-highlight' : ''
                        }`}
                      >
                        Version
                      </span>
                    </Form.Label>
                    <Form.Control
                      type='text'
                      placeholder='Enter version'
                      name='version'
                      className='required'
                      value={hsPending.version || ''}
                      onChange={handleChange}
                    />
                  </div>
                  <div className='col-md-12'>
                    <Form.Label className='text-primary me-0 ps-0' column>
                      <span
                        className={
                          isDifferent(hsOrigin.description, hsPending.description)
                            ? 'label-highlight'
                            : ''
                        }
                      >
                        Description
                      </span>
                    </Form.Label>
                    <SummernoteEditor
                      value={hsPending.description || ''}
                      onChange={(html) => {
                        const fakeEvent = {
                          target: {name: 'description', value: html},
                        } as any
                        handleChange(fakeEvent)
                      }}
                    />
                  </div>
                  <div className='col-md-12'>
                    <Form.Label className='text-primary me-0 ps-0' column>
                      <span
                        className={
                          isDifferent(hsOrigin.description_fr, hsPending.description_fr)
                            ? 'label-highlight'
                            : ''
                        }
                      >
                        Description (FR)
                      </span>
                    </Form.Label>
                    <SummernoteEditor
                      value={hsPending.description_fr || ''}
                      onChange={(html) => {
                        const fakeEvent = {
                          target: {name: 'description_fr', value: html},
                        } as any
                        handleChange(fakeEvent)
                      }}
                    />
                  </div>
                </div>
                <hr />
                <div className='row'>
                  <div className='col-12'>
                    <h3>Attributes</h3>
                  </div>
                  <div className='col-md-6'>
                    <Form.Label className='required text-primary me-0 ps-0' column>
                      <span
                        className={`required ${
                          isDifferent(hsOrigin.level, hsPending.level) ? 'label-highlight' : ''
                        }`}
                      >
                        Level
                      </span>
                    </Form.Label>
                    <Form.Control
                      type='text'
                      placeholder='Enter level'
                      name='level'
                      className='required'
                      value={hsPending.level ?? ''}
                      onChange={handleChange}
                    />
                  </div>
                  <div className='col-md-6'>
                    <Form.Label className='text-primary me-0 ps-0' column>
                      <span
                        className={
                          isDifferent(hsOrigin.parent, hsPending.parent) ? 'label-highlight' : ''
                        }
                      >
                        Parent
                      </span>
                    </Form.Label>
                    <Form.Control
                      type='text'
                      placeholder='Enter parent'
                      name='parent'
                      value={hsPending.parent ?? ''}
                      onChange={handleChange}
                    />
                  </div>
                </div>
                <div className='row pt-5'>
                  <div className='col-lg-12 d-flex justify-content-end gap-3'>
                    <Button variant='default' className='btn-cancel' onClick={handleCancel}>
                      Cancel
                    </Button>
                    <Button
                      variant='primary'
                      onClick={handleSubmit}
                      disabled={isLoadingButton || !isFormValid}
                    >
                      {isLoadingButton ? (
                        <>
                          <Spinner animation='border' size='sm' className='me-2' />
                          Submit
                        </>
                      ) : (
                        'Submit'
                      )}
                    </Button>
                  </div>
                </div>
              </Form>
            ) : (
              <div
                className='d-flex align-items-center justify-content-center'
                style={{height: '50vh'}}
              >
                <Spinner animation='border' role='status' variant='primary' className='me-3' />
                <div className='loading-text'>
                  Loading
                  <span className='dot'>.</span>
                  <span className='dot'>.</span>
                  <span className='dot'>.</span>
                </div>
              </div>
            )}
          </Card.Body>
        </Card>
      </Col>
    </Row>
  )
}

export default HSDescriptionPendingForm
